"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addCon: 'Add',
  addPhoto: 'Add photo',
  addPro: 'Add',
  agreeToDisplayProfilePicture: 'I agree to display my profile picture with my review',
  cancel: 'Cancel',
  clickOnStars: 'Click on the stars to leave review',
  close: 'Close',
  cons: 'Cons',
  consHelperText: 'e.g. difficult to remove, too expensive, fails expectations etc.',
  consPlaceholder: 'Add cons (optional)',
  delete: 'Delete review',
  deleteConfirmDescription: 'Are you sure you want to delete this review? Once it’s gone, it can’t be brought back.',
  discard: 'Discard changes',
  fiveStarReview: 'Excellent',
  fourStarReview: 'Good',
  gotIt: 'Got it',
  mainEditTitle: 'Edit your review',
  mainTitle: 'Leave your review',
  missingRequiredData: 'Some required fields are missing.',
  nameOrAlias: 'Your public name or alias',
  nameOrAliasPlaceholder: 'Your public name or alias',
  nameOrAliasRequired: 'Your public name or alias is required.',
  oneStarReview: 'Very poor',
  productReview: 'Write your product review',
  productReviewPlaceholder: '<p>Share your story! Your review helps us improve and helps others make the right choice.</p><br><ul><li>What made this product stand out?</li><li>Did it meet your expectations?</li><li>Did it fall short in any way?</li></ul><br><p>Remember to keep a nice tone, and that the review should reflect the product not customer experience or delivery</p>',
  pros: 'Pros',
  prosHelperText: 'e.g. moisturising, long lasting, easy to apply, value for money etc.',
  prosPlaceholder: 'Add pros (optional)',
  removeCon: 'Remove con',
  removePhoto: 'Remove photo',
  removePro: 'Remove pro',
  reviewFailDescription: 'Something went wrong and your review couldn’t be submitted. Please try again later.',
  reviewFailTitle: 'Review submission failed',
  reviewSuccessDescription: 'Your review has been submitted and is awaiting approval from our moderators. Once approved, it will appear on the product page',
  reviewSuccessTitle: 'Thanks for your review!',
  reviewUpdateSuccessDescription: 'Your edited review has been re-submitted for moderation. Once approved, it will appear on the product page.',
  reviewUpdateSuccessTitle: 'Thanks! Your review has been updated',
  reviewWasDeleted: 'Review was deleted',
  rulesAndGuidelines: "<p><strong>Writing guidelines</strong></p><br><p>Consider including the following:</p><ul><li>Why do you like or dislike this product?</li><li>How does it compare to similar products?</li><li>Who would you recommend it to?</li></ul><br><p>Try to keep your product review on topic.</p><ul><li>Don't comment on the seller or delivery service, or let this affect the product rating.</li><li>Don't include any links or personal information such as full names, addresses, phone numbers, etc.</li><li>Don't include advertisements or references to other offers or websites.</li></ul><br><p><strong>Photo guidelines</strong></p><br><p>When submitting images, please follow these guidelines:</p><ul><li>Image must be JPG, PNG, HEIC format</li><li>File size must be 10 MB or less</li><li>You may not submit images that are not owned by you</li></ul><br><p>Wait until you have received and tested the product before writing your review.</p><br><p>Contact customer service if you experience any problems with the delivery, or if the product was damaged or broken upon arrival.</p><br><p>Your review will be read by a moderator and will only be published if it meets these guidelines and our terms & conditions.</p>",
  save: 'Save changes',
  showRulesAndGuidelines: 'Show rules and guidelines',
  submit: 'Submit',
  threeStarReview: 'Fair',
  twoStarReview: 'Poor'
};
const translationsNamespace = exports.translationsNamespace = 'rating-and-review-dialog';
